const READY_CHANGE_INTELLIGENCE_TYPE = 'READY_CHANGE_INTELLIGENCE_TYPE'

const responseChangeIntelligenceType = (data) => {
  return {
    type: READY_CHANGE_INTELLIGENCE_TYPE,
    data
  }
}

const changeIntelligenceType = (data) => {
  return (dispatch) => {
    dispatch(responseChangeIntelligenceType(data))
  }
}

export {
  changeIntelligenceType,
  responseChangeIntelligenceType,
  READY_CHANGE_INTELLIGENCE_TYPE
}